import { call, put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { setFirstOnSceneOptions } from '../store/options.actions'
import { IOptionsResponse } from '../../../common/common.types'
import { OptionsService } from '../services/options.service'
import { getServiceIdSelector } from '../../user/selectors'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

export function* getFirstOnSceneOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getFirstOnSceneOptions])
    const { entity } = response
    yield put(setFirstOnSceneOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getFirstOnSceneOptions() error: ${e}`))
  }
}

export function* getFirstOnSceneOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getFirstOnSceneOptions)
}
